import Rails from '@rails/ujs';
import { Controller } from 'stimulus';

export default class extends Controller<HTMLFormElement> {
  verifyCaptcha(event: Event) {
    if (event.defaultPrevented) {
      return;
    }
    if (typeof hcaptcha === 'undefined' || hcaptcha.getResponse() !== '') {
      return;
    }

    event.preventDefault();

    const response = hcaptcha.execute(null, { async: true });
    if (response) {
      response.then(() => this.submit()).catch(() => this.reset());
    }
  }

  private submit() {
    if (this.element.requestSubmit) {
      this.element.requestSubmit();
    } else {
      this.element.submit();
    }
  }

  private reset() {
    hcaptcha.reset();
    Rails.enableElement(this.element);
  }
}
